import { carrierNames, Carriers, getCarrier } from "common/utils/CarrierUtils";
import { capitalize, tail } from "lodash/fp";

export const getShippingMethodLabel = (shippingMethod?: string) => {
  const carrierName = carrierNames[shippingMethod ? getCarrier(shippingMethod) : Carriers.OTHER];
  const labelArr = tail(shippingMethod?.split(".")).map(capitalize);
  return [carrierName, ...labelArr].join(" ");
};
